// extracted by mini-css-extract-plugin
export default {"container":"searchInput_container__9IGKN"};